import { jsx as _jsx } from "react/jsx-runtime";
var PlayroomDialogContent = function PlayroomDialogContent(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx("div", {
    className: "tw-p-2.4 dark:tw-text-neutral-light-100",
    children: children
  });
};
export default PlayroomDialogContent;